import axios from '@/libs/api.request.js'

export default {
    // 登录
    login: (data) => {
        return axios.request({
            url: 'platform/login',
            data,
            method: 'post'
        })
    },

    // 精选数据
    statisticData: () => {
        return axios.request({
            url: 'platform/statisticData',
            method: 'get'
        })
    },
    
    // 代理商列表
    agentList: (data) => {
        return axios.request({
            url: 'platform/index/agentList',
            data,
            method: 'post'
        })
    },
    
    // 商户列表
    merchantList: (data) => {
        return axios.request({
            url: 'platform/index/merchantList',
            data,
            method: 'post'
        })
    },

    // 待处理提成
    pendingRecord: (data) => {
        return axios.request({
            url: 'platform/pendingWithdrawalRecord',
            data,
            method: 'post'
        })
    },

    // 确认打款
    confirm: (params) => {
        return axios.request({
            url: 'platform/confirmWithdrawal',
            params,
            method: 'get'
        })
    },

    // 基本信息
    baseInfo: (params) => {
        return axios.request({
            url: 'platform/agentDetail',
            params,
            method: 'get'
        })
    },

    // 商户列表
    merchantList: (data) => {
        return axios.request({
            url: 'platform/agent/merchantList',
            data,
            method: 'post'
        })
    },

    // 收入记录
    incomeRecord: (data) => {
        return axios.request({
            url: 'platform/agent/incomeRecord',
            data,
            method: 'post'
        })
    },

    // 提现记录
    withdrawalRecord: (data) => {
        return axios.request({
            url: 'platform/agent/withdrawalRecord',
            data,
            method: 'post'
        })
    },
}